
































































































































































import {Component, Prop} from "vue-property-decorator";
import PrimaryPage from "@/layouts/primaryPage.vue";
import ajaxHelperInstance from "@/lib/ajaxhelper";
import SectionLayout from "@/layouts/sectionLayout.vue";
import PdfPreview from "@/components/pdfPreview.vue";
import basicPage from "@/layouts/basicPage.vue";
import ArticleOperationBar from "@/components/articleOperationBar.vue";
import VWangEditor from "@/components/v-wangEditor.vue";
import {paginationElement} from "@/api/typeDefined";
import AppConsts from "@/lib/appconst";
import keywordCard from "@/layouts/keywordCard.vue";
import util from "@/lib/util";

@Component({
  name: 'QADetail',
  components: {VWangEditor, ArticleOperationBar, PdfPreview, SectionLayout, PrimaryPage, keywordCard},
  filters: {
    imgUrlFilter(url: string = '') {
      if (url && url.indexOf('http') > -1) {
        return url;
      } else {
        let fileResourceUrl: string = AppConsts.fileResourceUrl;
        return `${fileResourceUrl}${url}`;
      }
    }
  }
})
export default class QADetail extends basicPage {
  @Prop({type: String, default: ''}) queryParams: string;
  questionId: string;
  //该问题是否解决
  isResolved: boolean = false;

  defRoutes = [{
    path: 'QA',
    breadcrumbName: 'Q & A'
  }];
  routeTokens: any = {};

  record: any = {};

  keywords: string;
  title: string = '';

  //推荐关键字
  recommendedkeywords: any[] = [];
  id: string = ''; // 推荐去除自己使用
  //所有回答
  allAnswers: any[] = [];
  loadingMore: boolean = false;
  showLoadingMore: boolean = true;

  answerForm;

  //分页
  pagination: paginationElement = {
    ...AppConsts.pagination,
    pageSize: 3,
    current: 0
  };

  //初始化分页参数
  initPagination() {
    this.allAnswers = [];
    this.pagination = {
      ...AppConsts.pagination,
      current: 0
    };
  }

  //获取数据
  fetchRecord(questionId: string) {
    ajaxHelperInstance.get('/web/question/findById', {questionId}, undefined, this).then((res) => {
      let {status, data} = res;
      if (status === 200) {
        this.record = data.data || {};
        // this.questionId = this.record.questionId || '';
        this.title = this.record.title;
        // this.fetchRecommendedkeywords(this.record.title);
        this.id = this.record.questionId;
        //是否解决
        this.isResolved = this.record.status === 1;

        //面包屑拼接
        // this.defRoutes.push({
        //     path: 'QADetail',
        //     breadcrumbName: this.record.title
        // });
        this.routeTokens = {
          "QATitle": this.record.title
        }

        this.loadMoreAnswers(this.questionId);
      }
    });
  }

  //更新是否解决状态
  freshIsResolve(questionId: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      ajaxHelperInstance.get('/web/question/findById', {questionId}).then((res) => {
        let {status, data} = res;
        if (status === 200) {
          let info = data.data || {};
          //是否解决
          resolve(info.status === 1);
        }
      });
    });
  }

  //获取推荐关键字（默认10条,模块: 1: 知识库; 2: Q&A; 空: 全部）
  fetchRecommendedkeywords(keywords: string = '') {
    let param = {moduleType: '2', keywords};
    ajaxHelperInstance.get('/web/global/query', param, undefined, this).then((res) => {
      let {status, data} = res;
      if (status === 200) {
        this.recommendedkeywords = data.data || [];
        console.log(this.recommendedkeywords);
      }
    });
  }

  //加载更多关于当前问题的回答
  loadMoreAnswers(questionId: string = this.questionId) {
    let {current, pageSize} = this.pagination;
    current++;//后一页
    const queryParams = {
      currentPage: current,
      pageSize: pageSize,
      questionId
    };

    this.loadingMore = true;
    ajaxHelperInstance.get('/web/answer/query', queryParams).then((res) => {
      let {status, data} = res;
      if (status === 200 && data) {
        let {errno, page} = data;
        if (errno === 0 && page) {
          let {total, currentPage, totalPage} = page;
          this.pagination.total = total || 0;
          this.pagination.current = currentPage;

          //拼接数据到后面
          if (totalPage >= currentPage) {
            let answers = data.data || [];
            if (answers) {
              for (let answer of answers) {
                answer.content = answer.content.replace(new RegExp("<img", "gm"), '<img width="500"');
              }
            }
            this.allAnswers = this.allAnswers.concat(answers);
            this.loadingMore = false;
            this.$nextTick(() => {
              window.dispatchEvent(new Event('resize'));
            });

            if (totalPage === currentPage) {
              this.showLoadingMore = false;
            }

          } else {//已经没有数据可以加载
            this.showLoadingMore = false;
          }
        } else {
          this.showLoadingMore = false;
        }
      }
    });
  }

  //提交我的回答
  handleSubmitAnswer(e) {
    e.preventDefault();
    this.answerForm.validateFields((err, values) => {
      if (!err) {
        let {content} = values;
        this.submitAnswer(content);
      }
    });
  }

  //提交回答
  submitAnswer(answerContent: string = '') {
    let param = {
      questionId: this.questionId,
      content: answerContent
    };
    ajaxHelperInstance.postM('/web/answer/add', param, this).then((res) => {
      let {status, data} = res;
      if (status === 200 && data) {
        let {message, errno} = data;
        if (errno === 0) {
          this.initPagination();
          //刷新回答列表
          this.loadMoreAnswers();
          this.$message.success(message);
        } else {
          this.$message.error(message);
        }
      }
    });
  }

  //可行点击事件
  handleClickWorkable(e: any, answerId: string, isQuestioner: boolean = false) {
    if (answerId && isQuestioner) {
      let param = {answerId: answerId};
      let _this = e;
      ajaxHelperInstance.get('/web/answer/believe', param).then((res) => {
        let {status, data} = res;
        let {errno} = data;
        if (status === 200 && errno === 0) {
          this.$nextTick(() => {
            _this.isActive = !_this.isActive;
          });

          //是否问题已解决
          this.freshIsResolve(this.questionId).then((isResolved: boolean) => {
            this.isResolved = isResolved;
          });
        }
      });
    }
  }

  //删除回答
  deleteAnswer(docId) {
    util.confirm({
      content: '是否确认要删除?',
      onOk: () => {
        let param = {answerId: docId};
        ajaxHelperInstance.get('/web/answer/delete', param, this).then((res) => {
          let {status, data} = res;
          if (status === 200 && data) {
            let {message, errno} = data;
            if (errno === 0) {
              this.initPagination();
              //刷新回答列表
              this.loadMoreAnswers();
              this.$message.success(message);
            } else {
              this.$message.error(message);
            }
          }
        });
      }
    })

  }

  deleteQuestion(docId) {
    util.confirm({
      content: '是否确认要删除?',
      onOk: () => {
        let param = {questionId: docId};
        ajaxHelperInstance.get('/web/question/delete', param, this).then((res) => {
          let {status, data} = res;
          if (status === 200 && data) {
            let {message, errno} = data;
            if (errno === 0) {
              this.$message.success(message);
              this.$router.push({
                name: 'QA'
              })
            } else {
              this.$message.error(message);
            }
          }
        });
      }
    })
  }

  //关键字搜索
  handleSearch(keywords: string = '') {
    this.keywords = keywords;
    this.showTabList();
  }

  //显示列表页
  showTabList() {
    let queryParams = JSON.stringify({keywords: this.keywords});
    this.switchRouting('QA', {
      queryParams: queryParams
    });
  }

  //显示
  show() {
    this.fetchRecord(this.questionId);
  }

  beforeCreate() {
    this.answerForm = this.$form.createForm(this);
  }

  mounted() {
    try {
      let obj = JSON.parse(this.queryParams);
      if (obj) {
        this.questionId = obj.questionId;
        this.keywords = obj.keywords;
        if (obj.skip !== false) {
          this.defRoutes = obj.skipPath ? [obj.skipPath] : [];
        }
      }
    } catch (e) {

    }
    this.show();
  }
}
